// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
} */
:root {
  --color: #fff;
}

header {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.07), 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: #212529;
  background-color: black;
}

.nav-area {
  background-color: black;
  color: white;
  display: flex;
  align-items: center;
  max-width: 100%;
  margin: 0 auto;
  padding: 10px 20px;
}

.logo {
  text-decoration: none;
  font-size: 25px;
  color: inherit;
  margin-right: 20px;
}

.menus {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  list-style: none;
  /* justify-content: flex-end; */
  padding: 0 10px;
}

.menu-items {
  position: relative;
  font-size: 14px;
}

.menu-items a {
  display: block;
  font-size: inherit;
  color: inherit;
  text-decoration: none;
}

.menu-items button {
  display: flex;
  align-items: center;
  color: inherit;
  font-size: inherit;
  border: none;
  background-color: transparent;
  cursor: pointer;
  width: 100%;
}

button span {
  margin-left: 3px;
}

.menu-items > a, .menu-items button {
  text-align: left;
  padding: 0.7rem 1rem;
}

.menu-items a:hover,
.menu-items button:hover {
  background-color: #f2f2f2;
}

.arrow::after {
  content: "";
  display: inline-block;
  margin-left: 0.28em;
  vertical-align: 0.09em;
  border-top: 0.42em solid;
  border-right: 0.32em solid transparent;
  border-left: 0.32em solid transparent;
}

.dropdown {
  position: absolute;
  right: 0;
  left: auto;
  box-shadow: 0 10px 15px -3px rgba(46, 41, 51, 0.08),
    0 4px 6px -2px rgba(71, 63, 79, 0.16);
  font-size: 0.875rem;
  z-index: 9999;
  min-width: 10rem;
  padding: 0.5rem 0;
  list-style: none;
  background-color: #fff;
  border-radius: 0.5rem;
  display: none;
}

.dropdown.show {
  display: block;
}

.dropdown .dropdown-submenu {
  position: absolute;
  left: 100%;
  top: -7px;
}

/* content */

.content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 20px;
}

.content h2 {
  margin-bottom: 1rem;
}

.content a {
  color: #cc3852;
  margin-right: 10px;
}

.loader {
  color: var(--color);
  font-weight: 600;
  padding: 10px;
  position: absolute;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
  font-size: 18px;
  z-index: 9;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.success {
  color: green;
  font-weight: 600;
}

.cross {
  padding: 0 10px;
  color: red;
}

.chakra-table tr th{
  text-transform: capitalize !important;
}

.searchBox {
	border: none;
	font-size: 12px;
}

.searchWrapper {
  padding: 0 5px;
  border-radius: 2px;
}

.multiSelectContainer li {
  padding: 0 10px;
  font-size: 14px;
}
/* .chakra-form-control input {
  height: var(--chakra-sizes-8);
}

.chakra-form-control .chakra-select {
  height: var(--chakra-sizes-8);
} */

/* @media(max-width: 1120px) {
  .lni-table-section {
      max-width: 900px !important;
  }
}
@media(max-width: 950px) {
  .lni-table-section {
      max-width: 600px !important;
  }
}
@media(max-width: 650px) {
  .lni-table-section {
      max-width: 400px !important;
  }
} */`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;;GAIG;AACH;EACE,aAAa;AACf;;AAEA;EACE,4EAA4E;EAC5E,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;yCACuC;EACvC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA,YAAY;;AAEZ;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;AACA;;;;;;GAMG;;AAEH;;;;;;;;;;;;;;GAcG","sourcesContent":["/* * {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n} */\n:root {\n  --color: #fff;\n}\n\nheader {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.07), 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  color: #212529;\n  background-color: black;\n}\n\n.nav-area {\n  background-color: black;\n  color: white;\n  display: flex;\n  align-items: center;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 10px 20px;\n}\n\n.logo {\n  text-decoration: none;\n  font-size: 25px;\n  color: inherit;\n  margin-right: 20px;\n}\n\n.menus {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  list-style: none;\n  /* justify-content: flex-end; */\n  padding: 0 10px;\n}\n\n.menu-items {\n  position: relative;\n  font-size: 14px;\n}\n\n.menu-items a {\n  display: block;\n  font-size: inherit;\n  color: inherit;\n  text-decoration: none;\n}\n\n.menu-items button {\n  display: flex;\n  align-items: center;\n  color: inherit;\n  font-size: inherit;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  width: 100%;\n}\n\nbutton span {\n  margin-left: 3px;\n}\n\n.menu-items > a, .menu-items button {\n  text-align: left;\n  padding: 0.7rem 1rem;\n}\n\n.menu-items a:hover,\n.menu-items button:hover {\n  background-color: #f2f2f2;\n}\n\n.arrow::after {\n  content: \"\";\n  display: inline-block;\n  margin-left: 0.28em;\n  vertical-align: 0.09em;\n  border-top: 0.42em solid;\n  border-right: 0.32em solid transparent;\n  border-left: 0.32em solid transparent;\n}\n\n.dropdown {\n  position: absolute;\n  right: 0;\n  left: auto;\n  box-shadow: 0 10px 15px -3px rgba(46, 41, 51, 0.08),\n    0 4px 6px -2px rgba(71, 63, 79, 0.16);\n  font-size: 0.875rem;\n  z-index: 9999;\n  min-width: 10rem;\n  padding: 0.5rem 0;\n  list-style: none;\n  background-color: #fff;\n  border-radius: 0.5rem;\n  display: none;\n}\n\n.dropdown.show {\n  display: block;\n}\n\n.dropdown .dropdown-submenu {\n  position: absolute;\n  left: 100%;\n  top: -7px;\n}\n\n/* content */\n\n.content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 3rem 20px;\n}\n\n.content h2 {\n  margin-bottom: 1rem;\n}\n\n.content a {\n  color: #cc3852;\n  margin-right: 10px;\n}\n\n.loader {\n  color: var(--color);\n  font-weight: 600;\n  padding: 10px;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  background-color: rgba(0, 0, 0, 0.3);\n  font-size: 18px;\n  z-index: 9;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.success {\n  color: green;\n  font-weight: 600;\n}\n\n.cross {\n  padding: 0 10px;\n  color: red;\n}\n\n.chakra-table tr th{\n  text-transform: capitalize !important;\n}\n\n.searchBox {\n\tborder: none;\n\tfont-size: 12px;\n}\n\n.searchWrapper {\n  padding: 0 5px;\n  border-radius: 2px;\n}\n\n.multiSelectContainer li {\n  padding: 0 10px;\n  font-size: 14px;\n}\n/* .chakra-form-control input {\n  height: var(--chakra-sizes-8);\n}\n\n.chakra-form-control .chakra-select {\n  height: var(--chakra-sizes-8);\n} */\n\n/* @media(max-width: 1120px) {\n  .lni-table-section {\n      max-width: 900px !important;\n  }\n}\n@media(max-width: 950px) {\n  .lni-table-section {\n      max-width: 600px !important;\n  }\n}\n@media(max-width: 650px) {\n  .lni-table-section {\n      max-width: 400px !important;\n  }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
